export default __webpack_public_path__ + "static/media/goopter-disinfection-robot-automatic-charging.7b23b241.png";